import Accordion from '../Accordion'
import Button from '../Button'
import Reveal from '../Reveal'
import { Section } from '../Section'
import { company } from '../../data/site'

/**
 * The FAQ - shown on the home page and /leistungen.
 *
 * New on the rebuild: the old site answered none of these anywhere, which left
 * the two questions every prospect actually has ("what does it cost", "do you
 * cover my area") unanswered. Every answer restates a documented fact and says
 * "auf Anfrage" where no figure exists rather than filling the gap.
 */

const ENTRIES = [
  {
    q: 'Welche Objekte verwalten Sie?',
    a: 'Wir betreuen Wohnungseigentümergemeinschaften (WEG-Verwaltung), einzelne Eigentumswohnungen (Sondereigentumsverwaltung) und Mehrfamilienhäuser (Mietverwaltung). Sprechen Sie uns gern auch dann an, wenn Ihr Objekt nicht in dieses Raster passt.',
  },
  {
    q: 'Was kostet die Verwaltung meines Objekts?',
    a: 'Das hängt von Objektgröße, Einheitenzahl und dem gewählten Paket ab - deshalb nennen wir keine Pauschalpreise. Im kostenlosen Erstgespräch sehen wir uns Ihr Objekt an und Sie erhalten ein konkretes Angebot auf Basis von Basic, Profi-Paket oder Profi-Paket-Plus.',
  },
  {
    q: 'Wie schnell erhalte ich eine Rückmeldung?',
    a: 'Innerhalb eines Werktages. Das gilt für Eigentümer wie für Mieter und ist ein Versprechen, an dem wir uns messen lassen.',
  },
  {
    q: 'Wie melde ich einen Schaden?',
    a: 'Am schnellsten über die CASA App: Anliegen inklusive Fotoanhang aufnehmen und absenden, den Bearbeitungsstatus verfolgen Sie anschließend in der App. Alternativ erreichen Sie uns jederzeit telefonisch oder per E-Mail.',
  },
  {
    q: 'In welcher Region sind Sie tätig?',
    a: 'Unser Sitz ist in Aldingen. Regionalität ist Teil unseres Konzepts: kurze Wege und regelmäßige Begehungen sind nur mit örtlicher Nähe möglich. Ob Ihr Objekt in unserem Einsatzgebiet liegt, klären wir in einem kurzen Telefonat.',
  },
  {
    q: 'Wie läuft der Wechsel von meiner bisherigen Verwaltung ab?',
    a: 'In vier Schritten: Terminanfrage, telefonische Bedarfsanalyse, Beratungsgespräch am Objekt und - wenn es für beide Seiten passt - die Übernahme der Verwaltung. Bis zum Angebot entstehen Ihnen keine Kosten.',
  },
]

/** Also feeds the FAQPage structured data on the home page (see pages/Home.jsx). */
export const faqEntries = ENTRIES

export default function FaqSection() {
  return (
    <Section tone="paper" id="faq">
      <div className="split split--copy-narrow" style={{ alignItems: 'start' }}>
        <Reveal className="sticky-aside">
          <p className="eyebrow">Häufige Fragen</p>
          <h2 style={{ marginTop: 'var(--s-4)' }}>
            Was Eigentümer uns am häufigsten fragen
          </h2>
          <p style={{ marginTop: 'var(--s-5)' }}>
            Ihre Frage ist nicht dabei? Rufen Sie uns an - Sie sprechen direkt
            mit jemandem aus dem Team, nicht mit einer Warteschleife.
          </p>
          <div className="btn-row" style={{ marginTop: 'var(--s-6)' }}>
            <Button href={company.phoneHref} variant="outline" iconBefore="phone">
              {company.phone}
            </Button>
          </div>
        </Reveal>

        <Reveal>
          <Accordion items={ENTRIES} />
        </Reveal>
      </div>
    </Section>
  )
}
